import React from 'react';

import { AppBar } from 'material-ui';
import ConnectedSearchBox from './Algolia/ConnectedSearchBox';
import ConnectedSortBy from './Algolia/ConnectedSortBy';

const isMobile = window.innerWidth < 450;

const TitleBar = props => {
  const { onSideClick } = props;
  return (
    <AppBar
      title={isMobile ? '' : 'BANNERS'}
      className="Header__appBar"
      onLeftIconButtonClick={() => {
        onSideClick();
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
        <ConnectedSearchBox />
        <ConnectedSortBy
          items={[{ value: 'creatives', label: 'Latest' }]}
          defaultRefinement="creatives"
        />
      </div>
    </AppBar>
  );
};

export default TitleBar;



// WEBPACK FOOTER //
// ./src/components/TitleBar.js